import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_REAL_ESTATE_PRODUCT_INVESTMENT } from "../../../config/api";

export const getRealEstateInvestment = createAsyncThunk(
  "getRealEstateInvestment/getOne",
  async (id, { rejectWithValue }) => {
    try {
      const response = await Client({
        method: "GET",
        path: `${API_REAL_ESTATE_PRODUCT_INVESTMENT}/investor/${id}`,
      });

      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
